import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
export type OffersHistoryFragment = {
	__typename: 'OfferHistory';
	id: string;
	country: any;
	dateRanges: Array<{ __typename?: 'DateRange'; end: any; start: any }>;
	package: {
		__typename?: 'Package';
		icon: string;
		id: string;
		iconWide: string;
		clearName: string;
		packageId: number;
		monetizationTypes: Array<Types.MonetizationType>;
	};
};

export const OffersHistoryFragmentDoc = gql`
	fragment OffersHistory on OfferHistory {
		__typename
		id
		country
		dateRanges {
			end
			start
		}
		package {
			icon
			id
			iconWide(profile: S160)
			clearName
			packageId
			monetizationTypes
		}
	}
`;
